import Header from '../Header'
import JobProfileSection from '../jobProfileSection'
import './index.css'

const Jobs = () => (
  <>
    <Header />
    <div className="job-profile-container">
      <JobProfileSection />
    </div>
  </>
)

export default Jobs
